import * as React from "react";
import type { SVGProps } from "react";
export const SvgLolUggLogoUWhite = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 32 33" {...props}>
    <g filter="url(#lol-ugg-logo-u-white_svg__a)">
      <rect width={30} height={30} x={1} fill="url(#lol-ugg-logo-u-white_svg__b)" rx={2} />
    </g>
    <path
      fill="#11112A"
      fillRule="evenodd"
      d="M19.307 8.446v10.781c-1.078.607-2.208.915-3.362.915s-2.284-.308-3.362-.915V8.447L10.218 9.49v11.032l.527.351c1.596 1.066 3.394 1.629 5.2 1.629s3.604-.563 5.2-1.629l.527-.351V9.49l-2.365-1.044Z"
      clipRule="evenodd"
    />
    <path
      fill="#3273FA"
      fillRule="evenodd"
      d="m15.965 6.839-1.183.522v7.724c.392.112.787.169 1.183.169s.79-.057 1.182-.169V7.361l-1.182-.522Z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient id="lol-ugg-logo-u-white_svg__b" x1={22} x2={9.5} y1={0} y2={30} gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#CDDCFE" />
      </linearGradient>
      <filter
        id="lol-ugg-logo-u-white_svg__a"
        width={32}
        height={33}
        x={0}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_13271_4929" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_13271_4929" result="shape" />
      </filter>
    </defs>
  </svg>
);
